import React from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { formatDate, learnerTypeAccentColor } from '../utils'

const onMouseEnter = (e) => {
  e.target.classList.add('hover')
}

const onMouseLeave = (e) => {
  e.target.classList.remove('hover')
}

const Assignment = ({
  data,
  index,
  onCreate,
  onSort,
  onAssign,
  onDelete,
  allowAssign,
  canDrop,
}) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: 'assignment',
      item: { id: data.id, index },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [data.id, index]
  )

  const [, drop] = useDrop(
    () => ({
      accept: ['assignment', 'question'],
      drop: (item, monitor) => {
        if (!canDrop) return

        if (item.cardType !== 'question') return

        const hoverIndex = index
        onCreate(item.id, hoverIndex)
      },
      hover: (item, monitor) => {
        if (item.cardType === 'question') return

        const dragIndex = item.index
        const hoverIndex = index

        if (dragIndex === hoverIndex) return

        const hoverBoundingRect = document
          .querySelector(`[data-id='${data.id}']`)
          .getBoundingClientRect()
        const hoverMiddleY =
          (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
        const clientOffset = monitor.getClientOffset()
        const hoverClientY = clientOffset.y - hoverBoundingRect.top

        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return

        onSort(dragIndex, hoverIndex)
        monitor.getItem().index = hoverIndex
      },
    }),
    [data.id, index, onCreate, onSort]
  )

  const opacity = isDragging ? 0 : 1
  const cursor = isDragging ? 'move' : 'pointer'
  const borderLeftColor = learnerTypeAccentColor(data.question.learnerType)
  const assignText = data.assignedAt ? formatDate(data.assignedAt) : 'Assign'

  return (
    <li
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-id={data.id}
      ref={(node) => drag(drop(node))}
    >
      <div
        className="assignment question-card"
        style={{ cursor, opacity, borderLeftColor }}
      >
        <div
          className="question"
          dangerouslySetInnerHTML={{ __html: data.question.text }}
        />
        <nav className="actions">
          {allowAssign && (
            <a onClick={() => onAssign(data)}>
              <span>{assignText}</span>
            </a>
          )}
          <a onClick={() => onDelete(data.id)}>
            <span>Remove</span>
          </a>
        </nav>
      </div>
    </li>
  )
}

export default Assignment
